// extracted by mini-css-extract-plugin
export default {"MeetingMotif":"MeetingMotif-module-b0162acfee47dc588347","icon":"MeetingMotif-module-e596d1372f555365c949"};